// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table td[data-v-60154356]{padding:0 0;white-space:nowrap;font-size:13px}", ""]);
// Exports
module.exports = exports;
